import { render, staticRenderFns } from "./PromoCreationForm.vue?vue&type=template&id=2b9e40d5&scoped=true"
import script from "./PromoCreationForm.vue?vue&type=script&lang=js"
export * from "./PromoCreationForm.vue?vue&type=script&lang=js"
import style0 from "./PromoCreationForm.vue?vue&type=style&index=0&id=2b9e40d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9e40d5",
  null
  
)

export default component.exports